import { getShapeTransfomer, registerToolRendererGroup } from "../util/shapeCategorySingleton"
import { useAppDispatch, useAppSelector } from "../../../store/hooks"
import RectBase from "../shapes/rect/RectBase";
import { Transform } from "../../../geometry/transformation";
import { RootState } from "../../../store/store";
import { endRubberline } from "../../../store/interaction";
import { useRef } from "react";
import { exitSelection, modelAddMultipleItemToSelection } from "../../../store/model";
import { strokeCorrection } from "../util/strokeCorrection";

const RectSelectSymbol = () => {

    const dispatch = useAppDispatch();
    const interaction = useAppSelector((state: RootState) => state.interaction);
    const shapes = useAppSelector((state: RootState) => state.model.present.model.shapes);
    const scale = useAppSelector((state: RootState) => state.interface.viewport.scale)
    const mousePosition = useAppSelector((state: RootState) => state.interface.mouseUnmodifiedPosition);
    const defaultRectSelectSettings = useAppSelector((state: RootState) => state.tool.toolSettings.rect_select.symbolRect)
    const selectionRect = useRef<RectSel>({ x: 0, y: 0, width: 0, height: 0 });
    const pointBuffer = interaction.rubberlineData.snapPoints;
    const shiftDown = useAppSelector(state => state.interaction.button.buttonHeld.shift)

    switch (pointBuffer.length) {
        case 0: {
            break;
        }
        case 1: {
            selectionRect.current = {
                height: mousePosition.y - pointBuffer[0].y,
                width: mousePosition.x - pointBuffer[0].x,
                ...pointBuffer[0],
            }
            return (
                <RectBase shapeProps={{
                    ...defaultRectSelectSettings,
                    strokeWidth: strokeCorrection(defaultRectSelectSettings.strokeWidth, scale),
                    transformation: Transform.translationTransform(pointBuffer[0].x, pointBuffer[0].y).m,
                    height: mousePosition.y - pointBuffer[0].y,
                    width: mousePosition.x - pointBuffer[0].x,
                }} />
            )
        }

        case 2: {
            if (!shiftDown) dispatch(exitSelection())
            const intersections = shapes.filter((shape: GeometricShape) => {
                console.log(shape);

                return getShapeTransfomer(shape.type)?.rectangleIntersectCheck(shape, selectionRect.current)
            });
            console.log("intersetions: ", intersections);

            const selectionList = intersections.map(i => i.id);
            dispatch(modelAddMultipleItemToSelection(selectionList))
            dispatch(endRubberline())
            break;
        }
        case 3: {
            break;
        }

        default:
            dispatch(endRubberline())
            break;
    }
    return (
        <>
        </>
    )
}

const createRectSelecSymbol = () => {
    return <RectSelectSymbol />
}

registerToolRendererGroup("rect_select", { toolRender: createRectSelecSymbol })